import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@portals-platform/ui';
import { useNavigate } from '@tanstack/react-router';
import { EyeIcon, InfoIcon, Trash2Icon } from 'lucide-react';
import { type ReactNode, useState } from 'react';
import type { CertificateRow } from '../../data-access/index.js';
import { DeleteCertificateDialog } from './delete-certificate-dialog.js';

function IconAction({
  label,
  onClick,
  children,
}: {
  label: string;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="icon-sm" aria-label={label} onClick={onClick}>
          {children}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}

export function ReferralInfoButton({ certificate }: { certificate: CertificateRow }) {
  return (
    <IconAction label={`Review referral for ${certificate.policyNumber}`} onClick={() => {}}>
      <InfoIcon aria-hidden="true" />
    </IconAction>
  );
}

export function CertificateActions({ certificate }: { certificate: CertificateRow }) {
  const navigate = useNavigate();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  return (
    <div className="flex items-center justify-center gap-1">
      <IconAction
        label={`View certificate ${certificate.policyNumber}`}
        onClick={() =>
          void navigate({
            to: '/certificates/$certificateId',
            params: { certificateId: certificate.id },
          })
        }
      >
        <EyeIcon aria-hidden="true" />
      </IconAction>

      <IconAction
        label={`Delete certificate ${certificate.policyNumber}`}
        onClick={() => setIsDeleteOpen(true)}
      >
        <Trash2Icon aria-hidden="true" />
      </IconAction>

      <DeleteCertificateDialog
        certificate={isDeleteOpen ? certificate : null}
        onClose={() => setIsDeleteOpen(false)}
      />
    </div>
  );
}
